kombi.currentYear = function() {
    function getYear() {
        const date = new Date()
        const year = date.getFullYear()
        return year
    }
    const yearElement = document.getElementById('year')
    const year = getYear()
    if (yearElement)  {
        yearElement.textContent = year
    }
}

kombi.inputNumberPlusMinusBtn = function() {
    var numberInput = document.getElementById('numberInput')
    var plusBtn = document.getElementById('plusBtn')
    var minusBtn = document.getElementById('minusBtn')

    plusBtn?.addEventListener('click', function () {
        numberInput.value = parseInt(numberInput.value) + 1
    })
    minusBtn?.addEventListener('click', function () {
        if (parseInt(numberInput.value) > 0) {
            numberInput.value = parseInt(numberInput.value) - 1
        }
    })
}    
